import { render, staticRenderFns } from "./suggestIndex.vue?vue&type=template&id=2ef59eea&scoped=true&"
import script from "./suggestIndex.vue?vue&type=script&lang=js&"
export * from "./suggestIndex.vue?vue&type=script&lang=js&"
import style0 from "./suggestIndex.vue?vue&type=style&index=0&id=2ef59eea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef59eea",
  null
  
)

export default component.exports